// This file is part of Indico.
// Copyright (C) 2002 - 2022 CERN
//
// Indico is free software; you can redistribute it and/or
// modify it under the terms of the MIT License; see the
// LICENSE file for more details.

import PropTypes from 'prop-types';
import React from 'react';

import '../../../styles/regform.module.scss';

export default function NoteTextInput({title}) {
  // code to remove not used error
  const titleconst = title;
  title = titleconst;
  return <div styleName="label"> </div>;
}

NoteTextInput.propTypes = {
  title: PropTypes.string.isRequired,
};
